<template>
  <div class="image-stamp-info">
    <InfoTitle
      title="水印设置"
      :button-text="stampUrl ? '更换' : '添加'"
      :fn="fn"
    />
    <Divider />
    <InfoTitle title="图片水印" />
    <img v-if="stampUrl" :src="stampUrl" alt="" class="image" />
    <LabelSlider
      label="透明度"
      type="opacity"
      :useModel="true"
      v-model="stamp.opacity"
    />
    <LabelSlider
      label="大小"
      :useModel="true"
      :max="maxStampSize.w"
      :min="40"
      :step="1"
      v-model="stamp.size"
    />
    <LabelSlider
      label="偏移量"
      :useModel="true"
      :max="stampPadding * 3"
      :min="10"
      :step="1"
      v-model="stamp.offset"
    />
    <LabelOption
      label="黑白效果"
      :optionList="stampTypeList"
      v-model="stamp.type"
    />
    <PositionSelector v-model="stamp.position" />
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import InfoTitle from "../base/InfoTitle";
import Divider from '../base/Divider';
import LabelSlider from "../base/LabelSlider";
import LabelOption from "../base/LabelOption";
import PositionSelector from "../base/StampPositionSelector";

export default {
  name: "ImageStampInfo",
  components: { InfoTitle, Divider, LabelSlider, LabelOption, PositionSelector },
  computed: {
    ...mapGetters(['maxStampSize', 'stampPadding']),
    stamp() {
      return this.$store.state.stamp;
    },
    stampUrl() {
      return this.stamp.url
    }
  },
  data() {
    return {
      stampTypeList: [
        { name: '无', value: '' },
        { name: '黑', value: 'black' },
        { name: '白', value: 'white' }
      ]
    }
  },
  methods: {
    ...mapMutations((['handleCurrentIcon', 'handleCurrentMenu'])),
    fn: function () {
      this.handleCurrentIcon('material');
      this.handleCurrentMenu('MaterialMenu');
    }
  }
}
</script>

<style scoped>
.image-stamp-info {
  background: rgba(248, 248, 248, 1);
  padding: 10px 12px;
}

.image {
  width: 100%;
  height: 124px;
  object-fit: cover;
  margin-top: 9px;
}
</style>
